import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 form-group" }
const _hoisted_3 = ["data-maska"]
const _hoisted_4 = { class: "col-12 form-group" }
const _hoisted_5 = { class: "col-12 form-group" }
const _hoisted_6 = ["data-maska"]
const _hoisted_7 = { class: "col-8 form-group" }
const _hoisted_8 = { class: "col-4 form-group" }

import useToast from '@/composables/useToast';
import { IAddressResponse } from '@/interfaces';
import { addressValidations } from '@/utils/form_validations';
import { numberMask, zipcodeMask } from '@/utils/masks';
import useVuelidate from '@vuelidate/core';
import { computed, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddressComponent',
  emits: ["onChange"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const {toastError} = useToast()
const street = ref("")
const number = ref("")
const zip_code = ref("")
const city = ref("")
const state = ref("")
const country = ref("BR")

const addressForm = computed(() => ({
    street: street.value,
    number: number.value,
    zip_code: zip_code.value,
    city: city.value,
    state: state.value,
    country: country.value
}))

const $v = useVuelidate(addressValidations(), {
    street,
    number,
    zip_code,
    city,
    state,
    country,
})

watch(addressForm, () => {
    $v.value.$touch()
    emit('onChange', {
        address: addressForm.value,
        form: $v.value,
    })
}, { deep: true, immediate: true })

watch(zip_code, () => {
    setTimeout(() => {
        getAddressFromZipCode()
    }, 300);
})


const getAddressFromZipCode = () => {
    const zipCode = zip_code.value.replace('-', '')
    if (zipCode.length == 8) {
        console.log('zip', zipCode)
        fetch(`https://viacep.com.br/ws/${zipCode.replace('-', '')}/json`).then(r => r.json())
            .then(elem => {
                if(elem.erro) {
                    street.value = ''
                    city.value = ''
                    state.value = ''
                    return toastError('Não foi possível encontrar o endereço para este CEP')
                }
                if (elem.logradouro) {
                    street.value = elem.logradouro
                }
                if (elem.localidade) {
                    city.value = elem.localidade
                }
                if (elem.uf) {
                    state.value = elem.uf
                }
            }).catch(r => console.log(r))
    }
}




return (_ctx: any,_cache: any) => {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("label", {
          for: "add_credit_card_zip_code",
          class: "form-label"
        }, "Cep", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "data-maska": _unref(zipcodeMask),
          id: "add_credit_card_zip_code",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((zip_code).value = $event)),
          placeholder: "00000-000"
        }, null, 8, _hoisted_3), [
          [_directive_maska],
          [
            _vModelText,
            zip_code.value,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("label", {
          for: "add_credit_card_street",
          class: "form-label"
        }, "Endereço", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          id: "add_credit_card_street",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref($v).street.$model) = $event)),
          placeholder: "Av. Paulista"
        }, null, 512), [
          [
            _vModelText,
            _unref($v).street.$model,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("label", {
          for: "add_credit_card_address_number",
          class: "form-label"
        }, "Número", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "data-maska": _unref(numberMask),
          id: "add_credit_card_address_number",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref($v).number.$model) = $event)),
          placeholder: "1000"
        }, null, 8, _hoisted_6), [
          [_directive_maska],
          [
            _vModelText,
            _unref($v).number.$model,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[8] || (_cache[8] = _createElementVNode("label", {
          for: "add_credit_card_address_city",
          class: "form-label"
        }, "Cidade", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          id: "add_credit_card_address_city",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref($v).city.$model) = $event)),
          placeholder: "São Paulo"
        }, null, 512), [
          [
            _vModelText,
            _unref($v).city.$model,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[9] || (_cache[9] = _createElementVNode("label", {
          for: "add_credit_card_address_state",
          class: "form-label"
        }, "Estado", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          id: "add_credit_card_address_state",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref($v).state.$model) = $event)),
          placeholder: "SP"
        }, null, 512), [
          [
            _vModelText,
            _unref($v).state.$model,
            void 0,
            { trim: true }
          ]
        ])
      ])
    ])
  ]))
}
}

})